/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

// @mui material components
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import { useState, useMemo } from "react";
import CheckIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Cancel";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

function CambiarContrasena({ props, onChangeUser, onClickGuardar, onClickCancelar }) {
  const { password, confirmpassword, passwordActual } = props;

  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [validPassword, setValidPassword] = useState(false);

  // show password states
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordconfirm, setShowPasswordconfirm] = useState(false);
  const [showPasswordActual, setShowPasswordActual] = useState(false);

  const toggleShowPassword = () => setShowPassword((show) => !show);
  const toggleShowPasswordConfirm = () => setShowPasswordconfirm((show) => !show);
  const toggleShowPasswordActual = () => setShowPasswordActual((show) => !show);

  const preventDefault = (e) => e.preventDefault();

  // Validaciones del password en tiempo real
  const passwordValidation = useMemo(() => ({
    length: password1.length >= 8,
    upper: /[A-Z]/.test(password1),
    lower: /[a-z]/.test(password1),
    number: /[0-9]/.test(password1),
    special: /[^A-Za-z0-9]/.test(password1),
  }), [password1]);

  const allValid = Object.values(passwordValidation).every(Boolean);

  return (
    <>
      <TextField
        value={passwordActual}
        type={showPasswordActual ? "text" : "password"}
        onChange={(e) => onChangeUser(e.target.value, "passwordActual")}
        label="Password actual"
        variant="outlined"
        style={{ width: "100%", marginBottom: "1.5rem" }}
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={toggleShowPasswordActual}
                onMouseDown={preventDefault}
                edge="end"
              >
                <Icon fontSize="small" color="secondary">
                  {showPasswordActual ? "visibility_off" : "visibility"}
                </Icon>
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <TextField
        value={password}
        type={showPassword ? "text" : "password"}
        onChange={(e) => {
          const value = e.target.value;
          if (value !== password2 && password2 !== "") {
            setValidPassword(true);
          } else {
            setValidPassword(false);
          }
          setPassword1(value);
          onChangeUser(value, "password");
        }}
        label="Password nuevo"
        variant="outlined"
        style={{ width: "100%", marginBottom: "1.5rem" }}
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={toggleShowPassword}
                onMouseDown={preventDefault}
                edge="end"
              >
                <Icon fontSize="small" color="secondary">
                  {showPassword ? "visibility_off" : "visibility"}
                </Icon>
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <TextField
        value={confirmpassword}
        type={showPasswordconfirm ? "text" : "password"}
        onChange={(e) => {
          if (e.target.value !== password1) {
            setValidPassword(true);
          } else {
            setValidPassword(false);
          }
          setPassword2(e.target.value);
          onChangeUser(e.target.value, "confirmpassword");
        }}
        error={validPassword}
        helperText={validPassword && "Las contraseñas no coinciden"}
        label="Confirmar password"
        variant="outlined"
        style={{ width: "100%", marginBottom: "1.5rem" }}
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={toggleShowPasswordConfirm}
                onMouseDown={preventDefault}
                edge="end"
              >
                <Icon fontSize="small" color="secondary">
                  {showPasswordconfirm ? "visibility_off" : "visibility"}
                </Icon>
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {/* Lista de validaciones */}
      <Grid container spacing={1} style={{ marginBottom: "1.5rem" }}>
        <Grid item xs={12}>
          <Typography variant="subtitle2" style={{color:"white"}}>
            La contraseña debe contener:
          </Typography>
        </Grid>

        {[
          { label: "Al menos 8 caracteres", valid: passwordValidation.length },
          { label: "Al menos una letra mayúscula", valid: passwordValidation.upper },
          { label: "Al menos una letra minúscula", valid: passwordValidation.lower },
          { label: "Al menos un número", valid: passwordValidation.number },
          { label: "Al menos un carácter especial", valid: passwordValidation.special },
        ].map((item, idx) => (
          <Grid item xs={12} key={idx} style={{ display: "flex", alignItems: "center" }}>
            {item.valid ? (
              <CheckIcon fontSize="small" style={{ color: "green", marginRight: 6 }} />
            ) : (
              <CloseIcon fontSize="small" style={{ color: "red", marginRight: 6 }} />
            )}
            <Typography variant="body2" style={{color:"white", fontSize:"0.8rem"}}>{item.label}</Typography>
          </Grid>
        ))}
      </Grid>

      <MDBox textAlign="right">
        <Button
          variant="contained"
          startIcon={<Icon>save</Icon>}
          onClick={onClickGuardar}
          size="small"
          color="primary"
          style={{ marginRight: "1rem" }}
          disabled={!allValid || validPassword}
        >
          Guardar
        </Button>
        <Button
          variant="contained"
          startIcon={<Icon>close</Icon>}
          onClick={onClickCancelar}
          size="small"
          color="primary"
        >
          Cancelar
        </Button>
      </MDBox>
    </>
  );
}

export default CambiarContrasena;
